/**
 * Created by Ivan on 16.04.2024
 */

const StickersCollectionWindow = CleverappsWindow.extend({
    ctor: function (collection) {
        this.collection = collection;

        this._super();
    },

    onWindowLoaded: function () {
        this._super({
            title: Messages.get(this.collection.title),
            name: "StickersCollectionWindow",
            content: this.getContent(),
            noPadding: true
        });

        cleverapps.UI.onClick(this.window, () => {
            this.onClick();
        }, {
            interactiveScale: false
        });
    },

    getContent: function () {
        const styles = cleverapps.styles.StickersCollectionWindow;

        const content = this.content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        content.setContentSize2(styles.size);
        content.setAlignment(styles);

        if (!(this.collection.isPrizeCollected && styles.jokers.hideOnComplete)) {
            const jokerAmount = new StickersBookJokerView("stickers_collection_window");
            jokerAmount.setAlignment(styles.jokers.position);
            content.addChild(jokerAmount);
            cleverapps.UI.onClick(jokerAmount, () => {
                this.collection.stickers.forEach((sticker, index) => {
                    if (sticker.getState() === Sticker.STATE_CLOSED) {
                        this.highlightSticker(index);
                    }
                });
            });
        }

        const progress = this.createProgress();
        content.addChild(progress);

        this.collection.on("update", this.createListener(() => {
            progress.updateProgress && progress.updateProgress(this.collection.getOpenedStickersAmount(), StickersCollection.STICKERS_IN_COLLECTION, {
                animated: true
            });
        }), this);

        this.addComponent();

        if (this.collection.isPrizeCollected && styles.stamp) {
            const stamp = new cc.Sprite(bundles.stickers_collection_window.frames.stamp_png);
            this.content.addChild(stamp);
            stamp.setAlignment(styles.stamp);
        }

        return content;
    },

    createProgress: function () {
        const styles = cleverapps.styles.StickersCollectionWindow;

        const currentValue = this.collection.getOpenedStickersAmount();
        const goalValue = StickersCollection.STICKERS_IN_COLLECTION;

        if (this.collection.isPrizeCollected) {
            const completedText = cleverapps.UI.generateOnlyText(Messages.get("StickersCollectionWindow.CompletedText"), cleverapps.styles.FONTS.WINDOW_TEXT);
            const checkmark = new cc.Sprite(bundles.stickers_collection_window.frames.checkmarks_png);
            const finishLabel = styles.checkmark ? new cleverapps.Layout([checkmark, completedText], {
                direction: cleverapps.UI.HORIZONTAL,
                margin: styles.checkmark.margin
            }) : completedText;
            finishLabel.setAlignment(styles.finish.position);
            return finishLabel;
        }

        const prizeBar = new PrizeBarComponent({
            onCollect: this.createListener(() => {
                this.collection.onPrizeCollect();
                this.close();

                cleverapps.focusManager.display({
                    focus: "StickersCompletedWindow",
                    stack: true,
                    action: (f) => {
                        new StickersCompletedWindow(this.collection.index);
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            }),
            reward: StickersBook.getCollectionReward(this.collection.index),
            progressBar: {
                progressImage: bundles.stickers_collection_window.frames.progress_bar_png,
                progressBgImage: bundles.stickers_collection_window.frames.progress_bar_bg_png,
                width: styles.prize.width,
                barText: {
                    dy: styles.text.dy
                }
            }
        });
        prizeBar.updateProgress(currentValue, goalValue);
        if (this.collection.isPrizeCollected) {
            prizeBar.setCollected();
        }

        if (bundles.stickers_collection_window.frames.stickers_png) {
            const stickersIcon = new cc.Sprite(bundles.stickers_collection_window.frames.stickers_png);
            stickersIcon.setScale(0.6);
            prizeBar.addChild(stickersIcon);
            stickersIcon.setAlignment(styles.stickers);
        }

        prizeBar.setAlignment(styles.prize.position);

        return prizeBar;
    },

    addTooltipHandler: function (stickerView) {
        if (!stickerView.sticker.isOpen()) {
            stickerView.clickHandler = cleverapps.UI.onClick(stickerView, () => {
                this.onClick(stickerView);
            }, {
                interactiveScale: false,
                onDoubleClick: cleverapps.config.debugMode && this.onDoubleClick.bind(this, stickerView)
            });
        }
    },

    highlightSticker: function (index) {
        const sticker = this.stickers[index];

        if (sticker.light) {
            return;
        }

        const light = sticker.light = new cleverapps.Spine(bundles.stickers_collection_window.jsons.highlight_sticker_json);

        if (light.hasSkin(index)) {
            light.setSkin(index);
        }

        sticker.addChild(light, -1);
        light.setAlignment(cleverapps.styles.StickersCollectionWindow.highlight);
        light.setAnimation(0, "animation", false);
        light.setCompleteListener(() => {
            sticker.light.removeFromParent();
            sticker.light = undefined;
        });
    },

    createStickerTooltip: function (target) {
        if (target.sticker.getState() !== Sticker.STATE_CLOSED) {
            return;
        }
        if (this.stickerTooltip && this.stickerTooltip.target === target) {
            return;
        }

        const styles = cleverapps.styles.StickersCollectionWindow.tooltip;
        const bg = new cleverapps.Spine(bundles.stickers_collection_window.jsons.tooltip_bg_json);
        bg.setAnchorPoint(0.5, 1);
        bg.setRotation(180);

        const text = new TextWithIcon(`!! ${Messages.get("WildCard.Button")}`, {
            icons: {
                "!!": bundles.stickers_collection_window.frames.double_joker_png
            },
            font: cleverapps.styles.FONTS.STICKER_JOKER_BUTTON_TEXT
        });

        const button = new cleverapps.UI.Button({
            width: styles.button.width,
            height: styles.button.height,
            content: text,
            disabled: cleverapps.stickersBook.jokers === 0,
            onClicked: function () {
                this.removeStickerTooltip();

                target.clickHandler.remove();
                target.clickHandler = undefined;

                this.collection.jokerAnimationActive = true;
                target.sticker.open(Sticker.SOURCES.joker);
                cleverapps.stickersBook.useJoker();

                this.close();

                cleverapps.focusManager.display({
                    stack: true,
                    focus: "UseJoker",
                    action: function (f) {
                        cleverapps.focusManager.currentWindow().useJokerAnimation(target.sticker, f);
                    }
                });
            }.bind(this)
        });

        bg.addChild(button);
        button.setRotation(180);
        button.setAlignment(styles.button);

        target.addChild(bg);
        bg.setAlignment(styles);
        bg.replaceParentSamePlace(this.content, 100);

        bg.setScale(0.2);
        bg.setOpacity(0);
        bg.runAction(new cc.Sequence(
            new cc.Show(),
            new cc.Spawn(
                new cc.FadeIn(0.1),
                new cc.ScaleTo(0.1, 1)
            ).easing(cc.easeInOut(2))
        ));

        this.stickerTooltip = bg;
        this.stickerTooltip.target = target;

        cleverapps.tutorial.trigger("stickers_collection_window_tooltip_shown");
    },

    removeStickerTooltip: function () {
        if (!this.stickerTooltip) {
            return;
        }
        const stickerTooltip = this.stickerTooltip;
        this.stickerTooltip = undefined;

        stickerTooltip.stopAllActions();
        stickerTooltip.runAction(
            new cc.Sequence(
                new cc.Spawn(
                    new cc.ScaleTo(0.2, 0.3),
                    new cc.FadeOut(0.2)
                ).easing(cc.easeInOut(2)),
                new cc.CallFunc(() => {
                    stickerTooltip.removeFromParent(true);
                })
            )
        );
    },

    onClick: function (target) {
        if (target && this.stickerTooltip && target === this.stickerTooltip.target) {
            return;
        }

        this.removeStickerTooltip();

        if (target) {
            this.createStickerTooltip(target);
        }
    },

    addComponent: function () {
        if (this.component) {
            this.component.removeFromParent();
            this.component = undefined;
        }

        const ComponentClass = StickersBook.isPuzzle() ? PuzzlesComponent : StickersComponent;
        this.component = new ComponentClass(this.collection);

        this.stickers = this.component.stickers;
        this.stickers.forEach((stickerView) => {
            this.addTooltipHandler(stickerView);
        });

        this.content.addChild(this.component);
        this.content.setLocalZOrder(5);
    },

    onDoubleClick: function (stickerView) {
        this.removeStickerTooltip();
        stickerView.sticker.open();
        this.addComponent();
    },

    onClose: function () {
        this.removeStickerTooltip();
        this.component.onClose();
    },

    listBundles: function () {
        return [StickersCollection.getCollectionBundle(this.collection.index, this.collection.season), "stickers_collection_window"];
    }
});

cleverapps.styles.StickersCollectionWindow = {
    x: { align: "center" },
    y: { align: "center" },

    size: [
        { width: 1000, height: 1250 },
        { width: 1000, height: 1250 },
        { width: 1570, height: 960 }
    ],

    prize: {
        position: [
            { x: { align: "center" }, y: { align: "top", dy: -30 } },
            { x: { align: "center" }, y: { align: "top", dy: -30 } },
            { x: { align: "center" }, y: { align: "top", dy: -50 } }
        ],
        width: 400
    },

    finish: {
        position: [
            { x: { align: "center" }, y: { align: "top", dy: -30 } },
            { x: { align: "center" }, y: { align: "top", dy: -30 } },
            { x: { align: "center" }, y: { align: "top", dy: -50 } }
        ]
    },

    textBg: {
        x: {
            align: "center"
        },
        y: {
            align: "bottom",
            dy: 15
        },
        width: 100
    },

    tooltip: {
        x: { align: "center", dx: 0 },
        y: { align: "center", anchor: false },
        button: {
            width: 280,
            height: 85,
            x: { align: "center" },
            y: { align: "center", dy: -20 }
        },
        arrow: {
            x: { align: "center", dx: 0 },
            y: { align: "top", dy: 18 },
            rotation: 180
        },
        text: {
            dimensionWidth: 160,
            maxWidth: 170,
            maxHeight: 90
        }
    },

    jokers: {
        position: [
            { x: { align: "right", dx: -64 }, y: { align: "top", dy: -24 } },
            { x: { align: "right", dx: -64 }, y: { align: "top", dy: -24 } },
            { x: { align: "right", dx: -60 }, y: { align: "top", dy: -34 } }
        ]
    },

    checkmark: {
        margin: 20
    },

    highlight: {
        x: { align: "center" },
        y: { align: "center" }
    },

    text: {
        dy: 4
    },

    stickers: {
        x: { align: "left", dx: -30 }, y: { align: "center", dy: -5 }
    }
};
